import OurStatistics from "../../../assets/images/our-statistics.png";
import { useComponentInView } from "../../../hooks/useComponentInView";
import useOutputReportStore from "../../../store/OutputReport.store";
import "../staticPageReport.scss";

const StaticPageTwo = () => {
  const { ref } = useComponentInView();

  const metadata = useOutputReportStore().metadata;
  const sectionMetadata = metadata?.FirmOverview || {};
  const { sectionKeyKebab } = sectionMetadata;

  if (!metadata?.Cover?.data) return null;

  return (
    <article
      ref={ref}
      id={`section-${sectionKeyKebab}-2`}
      className="static-page-report report-article"
    >
      <header className="section-title report-article__header">
        <h1>
          Allspring—seriously <span>smart</span> about SMAs with Remi
        </h1>
        <div className="section-title__sub">
          Remi is Allspring's platform that combines technology with investment
          expertise which allows for tax management and customizing SMAs at
          scale.
        </div>
      </header>

      <div className="report-article__content">
        <section className="report-article__visual">
          <div className="card">
            <section className="card__section">
              <div className="static-page-report__card-content">
                <div className="static-page-report__card-images">
                  <img src={OurStatistics} alt="Our statistics" />
                </div>
              </div>
            </section>
          </div>
          <div className="static-page-report__footnote">
            1 Allspring as of 30 September 2023. 2 Cerulli as of 3Q2023, among
            all firms providing managed account offerings.{" "}
            <b>Past performance is no guarantee of future results.</b>
            <br />
            Ratings and awards are shown for illustrative purposes only and are
            not a guarantee of future performance. Ratings and awards should not
            be relied upon when making an investment decision.
            <p className="static-page-report__footnote-legal">
              For Investment Professional Use Only In One-On-One Presentation
              With Client
            </p>
          </div>
        </section>
      </div>
    </article>
  );
};

export default StaticPageTwo;
